import { PicklesEffects } from 'src/app/travelxnew/store/effects/pickles.effects';
import { OrientationsEffects } from 'src/app/travelxnew/store/effects/orientations.effects';

export const travelXNewEffects = [PicklesEffects, OrientationsEffects];
